<template>
  <section class="not_found">
    <div class="container">
      <div class="content">
        <h1>404</h1>

        <p class="description" v-html="description"></p>

        <div class="cta_container">
          <primary-button
            @click.prevent="history.back()"
            v-if="parsedPrimary"
            :label="parsedPrimary.title"
            :link="parsedPrimary"
            theme="not_found_cta"
          ></primary-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';

export default {
  props: {
    title: {
      default: 'Error 404',
    },
    exp: {
      default: 'Page not found',
    },
    description: {
      default:
        'Looks like you’ve hit a dead-end, or the page you’re looking for might be under construction. Visit our homepage to get back on track or contact us for support.',
    },
    not_found_primary_cta: {},
  },

  computed: {
    parsedPrimary() {
      if (this.not_found_primary_cta) {
        return JSON.parse(this.not_found_primary_cta);
      } else {
        return null;
      }
    },

    previousPage() {
      return {
        url: '/',
        target: '_self',
        title: 'Previous Page',
      };
    },

    homePage() {
      return {
        url: '/',
        target: '_self',
        title: 'Homepage',
      };
    },
  },

  watch: {},

  methods: {},

  components: {
    PrimaryButton,
  },

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.not_found {
  background: white;
  padding: 100px 0;
  display: block;
  position: relative;
  overflow: hidden;

  @media (max-width: $mobile-xl) {
    padding: 16px 16px 32px;
    // margin-bottom: 75px;
  }

  .container {
    position: relative;
    z-index: 25;
    align-content: center;

    @media (min-width: $mobile-xl) {
      max-width: 100%;
      padding: 0;
    }

    @media (max-width: $mobile-xl) {
      row-gap: 50px;
      padding: 0;
      margin: 0;
      width: 100%;
      max-width: 100%;
    }

    .content {
      display: flex;
      flex-direction: column;
      grid-column: 4 / span 6;
      justify-content: flex-end;

      @media (max-width: $mobile-xl) {
        grid-column: span 4;
      }

      h1 {
				text-align: center;
			}

      .title {
        color: var(--navy);
        margin: 0 auto;
        text-align: center;
        padding: 0;
      }

      .exp {
        color: var(--orange);
        margin: 0 auto;
        text-align: center;
        padding: 0;
      }

      .description {
        margin: 55px auto 55px;
        color: var(--navy);
        text-align: left;
      }

      .cta_container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: var(--spacer);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/NotFound.vue